var _ = require("lodash");
module.exports = _.reduce(["date", "period", "domain", "unit", "department", "category", "center", "type", "amtEur"], function (a, v, k) {
  a[v] = k;
  return a;
}, {});